<div class="dialog-container">

  <div class="dialog-header">
    <span class="dialog-title">Validação Logística</span>
    <div class="flex items-center gap-2">
      <button mat-button class="btn-tg" (click)="load()" [disabled]="loading">
        @if (loading) { Carregando... } @else { Verificar novamente }
      </button>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-body">

    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (!loading && validacaoError) {
      <div class="empty-state">
        <mat-icon style="color:#ef4444">error_outline</mat-icon>
        <p>Não foi possível carregar a validação. Tente novamente.</p>
      </div>
    }

    @if (!loading && validacao) {

      <!-- Discrepâncias de Quantidade -->
      <div class="section-card">
        <span class="section-title">
          Discrepâncias de Quantidade
          @if ((validacao.discrepanciasQuantidade?.length ?? 0) === 0) {
            <span class="badge-green">OK</span>
          } @else {
            <span class="badge-red">{{ validacao.discrepanciasQuantidade?.length }} problema(s)</span>
          }
        </span>

        @if ((validacao.discrepanciasQuantidade?.length ?? 0) > 0) {
          <table-list-simple
            [dataSource]="validacao.discrepanciasQuantidade"
            [columns]="quantidadeColumns"
          />
        } @else {
          <p class="no-issues">Nenhuma discrepância de quantidade encontrada.</p>
        }
      </div>

      <!-- Discrepâncias de Trecho -->
      <div class="section-card">
        <span class="section-title">
          Discrepâncias de Trecho
          @if ((validacao.discrepanciasTrecho?.length ?? 0) === 0) {
            <span class="badge-green">OK</span>
          } @else {
            <span class="badge-red">{{ validacao.discrepanciasTrecho?.length }} problema(s)</span>
          }
        </span>

        @if ((validacao.discrepanciasTrecho?.length ?? 0) > 0) {
          <table-list-simple
            [dataSource]="validacao.discrepanciasTrecho"
            [columns]="trechoColumns"
          />
        } @else {
          <p class="no-issues">Nenhuma discrepância de trecho encontrada.</p>
        }
      </div>

    }

  </div>
</div>
